module.exports = __webpack_public_path__ + "img/pricing-tree-3.53d5a4ca.png";